import type { LocalizedText } from "../../api/CertRoadmap/types";
import type { VideoSegment } from "./types";

const ROADMAP_VIDEO_ID = "GHumqFJqpy4";

export const ROADMAP_INTRO: LocalizedText = {
  en: "Turn your goals into a clear career path with certifications and skills tailored to your experience and ambitions.",
  ar: "حوّل أهدافك إلى مسار مهني واضح من خلال الشهادات والمهارات المناسبة لخبرتك وطموحاتك.",
};

const toSeconds = (stamp: string) => {
  const [hours, minutes, seconds] = stamp.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};

export const credentialSegments: Record<string, VideoSegment> = {
  fmaa: { start: toSeconds("00:39:28"), end: toSeconds("00:49:41") },
  certifr: { start: toSeconds("00:49:42"), end: toSeconds("00:57:14") },
  dipifr: { start: toSeconds("00:57:15"), end: toSeconds("01:07:13") },
  cma: { start: toSeconds("01:07:14"), end: toSeconds("01:20:05") },
  csca: { start: toSeconds("01:20:06"), end: toSeconds("01:27:23") },
  cgma: { start: toSeconds("01:27:24"), end: toSeconds("01:40:02") },
  fmva: { start: toSeconds("01:40:03"), end: toSeconds("01:47:11") },
  afm: { start: toSeconds("01:47:12"), end: toSeconds("01:54:47") },
  fpap: { start: toSeconds("01:54:48"), end: toSeconds("02:01:42") },
  fpac: { start: toSeconds("02:01:43"), end: toSeconds("02:09:09") },
  bida: { start: toSeconds("02:09:10"), end: toSeconds("02:14:44") },
  ctp: { start: toSeconds("02:14:45"), end: toSeconds("02:23:53") },
  frm: { start: toSeconds("02:23:54"), end: toSeconds("02:34:45") },
  cfa: { start: toSeconds("02:34:46"), end: toSeconds("02:48:43") },
  cia: { start: toSeconds("02:48:44"), end: toSeconds("02:57:25") },
  crma: { start: toSeconds("02:57:26"), end: toSeconds("03:04:27") },
  cisa: { start: toSeconds("03:04:28"), end: toSeconds("03:13:09") },
  cfe: { start: toSeconds("03:13:10"), end: toSeconds("03:19:46") },
  cpa: { start: toSeconds("03:19:47"), end: toSeconds("03:33:21") },
  acca: { start: toSeconds("03:33:22"), end: toSeconds("03:48:54") },
  esaa: { start: toSeconds("03:48:55"), end: toSeconds("03:54:42") },
  socpa: { start: toSeconds("03:54:43"), end: toSeconds("04:00:21") },
  pmp: { start: toSeconds("04:00:22"), end: toSeconds("04:05:19") },
  adit: { start: toSeconds("04:05:20"), end: toSeconds("04:10:38") },
  cta: { start: toSeconds("04:10:39"), end: toSeconds("04:10:57") },
  professional_mba_dba: {
    start: toSeconds("04:10:58"),
    end: toSeconds("04:19:59"),
  },
};

export const embedUrlFor = (segment: VideoSegment) =>
  `https://www.youtube.com/embed/${ROADMAP_VIDEO_ID}?start=${segment.start}&end=${segment.end}&autoplay=1&rel=0`;
